<template>
  <div class="customize_container">
    <div class="customize_title">
      <!-- <div class="step">Step 3</div> -->
      <div class="step_title">選擇你想要的文字</div>
    </div>
    <div class="center">
      <div class="customize_step3">
        <component
          :is="displayMetalTextComponentName"
          class="metal_text"
          ref="metalTextComponentRef"
        ></component>
      </div>
      <div class="pic_changed">
        <div class="customProduct" ref="printMe">
          <component :is="displayComponentName"></component>
        </div>
      </div>
    </div>
    <!-- 此處用 back 是因為上一步可能回到 step 2 或 customize_gift -->
    <StepPreNext
      @preClick="back"
      @nextClick="$router.push({ name: 'customize_step4' })"
    ></StepPreNext>
  </div>
</template>

<script>
import customizeMetalA from "@/components/customizeMetal/traditionalMetal/CustomizeMetalA.vue";
import customizeMetalB from "@/components/customizeMetal/traditionalMetal/CustomizeMetalB.vue";
import customizeMetalC from "@/components/customizeMetal/traditionalMetal/CustomizeMetalC.vue";
import customizeMetalD from "@/components/customizeMetal/traditionalMetal/CustomizeMetalD.vue";
import customizeMetalE from "@/components/customizeMetal/traditionalMetal/CustomizeMetalE.vue";
import customizeMetalF from "@/components/customizeMetal/traditionalMetal/CustomizeMetalF.vue";
import customizeMetalG from "@/components/customizeMetal/traditionalMetal/CustomizeMetalG.vue";
import customizeMetalH from "@/components/customizeMetal/traditionalMetal/CustomizeMetalH.vue";
import customizeMetalI from "@/components/customizeMetal/traditionalMetal/CustomizeMetalI.vue";
import customizeMetalJ from "@/components/customizeMetal/traditionalMetal/CustomizeMetalJ.vue";
import customizeMetalK from "@/components/customizeMetal/traditionalMetal/CustomizeMetalK.vue";
import customizeMetalL from "@/components/customizeMetal/traditionalMetal/CustomizeMetalL.vue";
import customizeMetalM from "@/components/customizeMetal/traditionalMetal/CustomizeMetalM.vue";
import customizeMetalN from "@/components/customizeMetal/traditionalMetal/CustomizeMetalN.vue";
import customizeMetalO from "@/components/customizeMetal/traditionalMetal/CustomizeMetalO.vue";
import customizeMetalP from "@/components/customizeMetal/traditionalMetal/CustomizeMetalP.vue";
import customizeMetalQ from "@/components/customizeMetal/traditionalMetal/CustomizeMetalQ.vue";
import customizeMetalR from "@/components/customizeMetal/traditionalMetal/CustomizeMetalR.vue";
import customizeMetalS from "@/components/customizeMetal/traditionalMetal/CustomizeMetalS.vue";
import customizeMetalT from "@/components/customizeMetal/traditionalMetal/CustomizeMetalT.vue";
import customizeMetalU from "@/components/customizeMetal/traditionalMetal/CustomizeMetalU.vue";
import customizeMetalV from "@/components/customizeMetal/traditionalMetal/CustomizeMetalV.vue";
import customizeMetalW from "@/components/customizeMetal/traditionalMetal/CustomizeMetalW.vue";
import customizeMetalX from "@/components/customizeMetal/traditionalMetal/CustomizeMetalX.vue";
import customizeMetalY from "@/components/customizeMetal/traditionalMetal/CustomizeMetalY.vue";
import customizeMetalZ from "@/components/customizeMetal/traditionalMetal/CustomizeMetalZ.vue";
import customizeMetalAA from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAA.vue";
import customizeMetalAB from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAB.vue";
import customizeMetalAC from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAC.vue";
import customizeMetalZA from "@/components/customizeMetal/traditionalMetal/CustomizeMetalZA.vue";
import customizeMetalAD from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAD.vue";
import customizeMetalAE from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAE.vue";
import customizeMetalAH from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAH.vue";
import customizeMetalAI from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAI.vue";
import customizeMetalAJ from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAJ.vue";
import customizeMetalAK from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAK.vue";
import customizeMetalAL from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAL.vue";
import customizeMetalAM from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAM.vue";
import customizeMetalAN from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAN.vue";
import customizeMetalAO from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAO.vue";
import customizeMetalAP from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAP.vue";
import customizeMetalAQ from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAQ.vue";
import customizeMetalAR from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAR.vue";
import customizeMetalAS from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAS.vue";
import customizeMetalAT from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAT.vue";
import customizeMetalAU from "@/components/customizeMetal/traditionalMetal/CustomizeMetalAU.vue";
import customizeMetalBA from "@/components/customizeMetal/traditionalMetal/CustomizeMetalBA.vue";
import customizeMetalAV from "@/components/customizeMetal/CustomizeMetalAV.vue";
import customizeMetalAW from "@/components/customizeMetal/CustomizeMetalAW.vue";
import customizeMetalAX from "@/components/customizeMetal/CustomizeMetalAX.vue";
import StepPreNext from "@/components/StepPreNext.vue";
import MetalTextDefault from "./components/MetalTextDefault.vue";
import MetalTextCommemorativeLicensePlate from "./components/MetalTextCommemorativeLicensePlate.vue";
import MetalTextCommemorativeDoorplate from "./components/MetalTextCommemorativeDoorplate.vue";
import MetalTextCommemorativeMedal from "./components/MetalTextCommemorativeMedal/index.vue";
import { displayMetalTextComponentNameMap } from "./constData.js";

export default {
  name: "customizeStep3",
  components: {
    StepPreNext,
    MetalTextDefault,
    MetalTextCommemorativeLicensePlate,
    MetalTextCommemorativeDoorplate,
    MetalTextCommemorativeMedal,
    customizeMetalA,
    customizeMetalB,
    customizeMetalC,
    customizeMetalD,
    customizeMetalE,
    customizeMetalF,
    customizeMetalG,
    customizeMetalH,
    customizeMetalI,
    customizeMetalJ,
    customizeMetalK,
    customizeMetalL,
    customizeMetalM,
    customizeMetalN,
    customizeMetalO,
    customizeMetalP,
    customizeMetalQ,
    customizeMetalR,
    customizeMetalS,
    customizeMetalT,
    customizeMetalU,
    customizeMetalV,
    customizeMetalW,
    customizeMetalX,
    customizeMetalY,
    customizeMetalZ,
    customizeMetalAA,
    customizeMetalAB,
    customizeMetalAC,
    customizeMetalZA,
    customizeMetalAD,
    customizeMetalAE,
    customizeMetalAH,
    customizeMetalAI,
    customizeMetalAJ,
    customizeMetalAK,
    customizeMetalAL,
    customizeMetalAM,
    customizeMetalAN,
    customizeMetalAO,
    customizeMetalAP,
    customizeMetalAQ,
    customizeMetalAR,
    customizeMetalAS,
    customizeMetalAT,
    customizeMetalAU,
    customizeMetalAV,
    customizeMetalAW,
    customizeMetalAX,
    customizeMetalBA,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.fromRoute = from.name;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "customize_step4") {
      const ref = this.$refs.metalTextComponentRef;
      if (ref && typeof ref.checkoutTextLimit === "function") {
        let checkoutTextLimitResult = ref.checkoutTextLimit();
        if (checkoutTextLimitResult == "over") {
          alert("請輸入字數限制內的文字");
          next(false);
          return;
        }
      } else {
        console.warn("子組件未實現 checkoutTextLimit 方法");
      }
      // 添加 class 隱藏邊框
      this.$refs.printMe.classList.add("remove-border");
      // 等待 DOM 更新後生成圖片
      // this.$nextTick(() => {
      // });
      this.saveToImg();
      this.$store.dispatch("setIsGoToStep3", true);
      next();
    } else {
      next();
    }
  },
  created() {
    let componentCode = this.$store.getters.getComponentCode;
    this.displayComponentName = "customizeMetal" + componentCode;
    this.handleMetalTextComponentName(componentCode);
  },
  data() {
    return {
      displayComponentName: "customizeMetalA",
      displayMetalTextComponentName: "MetalTextDefault",
      fromRoute: "",
    };
  },
  methods: {
    handleMetalTextComponentName(componentCode) {
      const engravingContentType =
        this.$store.getters.customizeMetalEngravingContentTypeByComponentCode(
          componentCode
        );
      this.displayMetalTextComponentName =
        displayMetalTextComponentNameMap[engravingContentType];
    },
    async saveToImg() {
      let canvasData = "";
      const el = this.$refs.printMe;
      canvasData = await this.$html2canvas(el, { backgroundColor: null });
      this.$store.dispatch("updataCanvasDataUrl", canvasData.toDataURL());
    },
    back() {
      if (this.fromRoute === "customize_sacred_object") {
        this.$router.push({ name: "customize_sacred_object" });
      } else if (this.fromRoute === "customize_gift") {
        this.$router.push({ name: "customize_gift" });
      } else {
        this.$router.push({ name: "customize_step2" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.customize_container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 60px;
  ::v-deep .step-pre-next {
    @include table {
      top: 360px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 30px 120px;
  z-index: 99;
  position: relative;
  @media all and (min-width: 1440px) {
    margin: 30px 8.3%;
  }
  @include table {
    grid-template-columns: 1fr;
    z-index: 1;
  }
  @include betweenPhoneTable {
    margin: 30px 0px;
  }
}
.customize_step3 {
  color: $secondaryDeepColor1;
  font-size: 17px;
  text-align: left;
  padding-left: 50px;
  margin: 0 auto;
  @include tablePro {
    padding-left: 20px;
  }
  @include betweenTableTablePro {
    padding-left: 0px;
  }
  @include table {
    order: 2;
  }
  @include betweenPhoneTable {
    padding: 0 20px;
  }
}
::v-deep .metal_text {
  p,
  input {
    max-width: 405px;
    width: 100%;
  }
  input {
    box-sizing: border-box;
    height: 55px;
    border-radius: 2px;
    border: 1px $primaryDeepColor solid;
    padding-left: 10px;
    background-color: #fefff9;
    color: $secondaryDeepColor1;
    font-size: 17px;
  }
  input::placeholder {
    color: $secondaryLightColor1;
  }
  .form-title-container {
    display: flex;
    justify-content: space-between;
    margin: 17px 0;
    p {
      margin: 0;
    }
  }
  .note {
    color: $secondaryColor2;
  }
  .dropdown_title {
    position: relative;
    a,
    span {
      box-sizing: border-box;
      color: $secondaryDeepColor1;
      text-decoration: none;
      display: flex;
      align-items: center;
      border: 1px $primaryDeepColor solid;
      background-color: #fefff9;
      padding: 15px 15px 15px 10px;
      max-width: 405px;
      width: 100%;
    }
    span:hover {
      color: $secondaryColor3;
      background-color: $primaryLightColor;
    }
    .title-color {
      color: $secondaryLightColor1;
    }
    ul {
      display: block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    .choice {
      position: absolute;
      width: 100%;
      max-height: 155px;
      overflow: scroll;
    }
    .fa {
      margin-left: auto;
      color: $primaryLightColor;
    }
  }
}
.pic_changed {
  width: 500px;
  margin-bottom: 30px;
  padding: 0 10px;
  div {
    width: 500px;
    height: 400px;
    object-fit: contain;
  }
  @include betweenTableTablePro {
    width: 400px;
    div {
      width: 400px;
      height: 320px;
      object-fit: contain;
    }
  }
  @include table {
    order: 1;
    width: 350px;
    justify-self: center;
    margin-bottom: 115px;
    padding: 0px;
    div {
      width: 350px;
      height: 280px;
      object-fit: contain;
    }
  }
  @include phone {
    width: 320px;
    margin-bottom: 150px;
    div {
      width: 320px;
      height: 256px;
      object-fit: contain;
    }
  }
}
::v-deep .remove-border {
  .templeName,
  .godName,
  .godName-first,
  .godName-last,
  .gift,
  .commemorativeLicensePlateNumber,
  .commemorativeLicensePlateImageText,
  .doorplate_image,
  .commemorativeDoorplateDistrict,
  .commemorativeDoorplateRoadName,
  .commemorativeDoorplateHouseNumber,
  .commemorativeMedalGreetingsAndName,
  .commemorativeMedalGreetingMessage,
  .commemorativeMedalSenderName,
  .commemorativeMedalGreetingImage {
    border: none !important;
  }
}
</style>
